import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const locationQuerySchema = z.object({
  id: z.number(),
  name: z.string(),
  status: statusQuerySchema,
});

export type LocationQuerySchema = z.infer<typeof locationQuerySchema>;

export const locationQueryAllSchema = paginatedResponseSchema(locationQuerySchema);
export type LocationQueryAllSchema = z.infer<typeof locationQueryAllSchema>;
